import React, { useEffect, useState } from 'react'

import { SVGIcon } from '../../wrappers/SVGIcon';

import { ICommonScanCriteria } from '../../../interfaces/scan_criterias';
import { Icons } from '../../../data/Assets';

interface IResultAccordionProps {
    maxLevel: number;
    scanCriteria: ICommonScanCriteria;
};

const ResultAccordion = (props: IResultAccordionProps) => {
    const { maxLevel, scanCriteria } = props;

    const [accordionMap, setAccordionMap] = useState(new Map<number, boolean>());

    const toggleAccordion = (index: number) => {
        const newAccordionMap = new Map(accordionMap);
        newAccordionMap.set(index, !accordionMap.get(index));
        setAccordionMap(newAccordionMap);
    }

    const getIndicatorClass = (level: number) => {
        if (maxLevel === 4) {
            if (level === 4) return 'success';
            if (level === 3) return 'primary';  // You might want to change this to 'warning' or a valid color if needed
            if (level === 2) return 'grey';  // 'orange' might not be valid; ensure 'SVGIconColor' accepts it
            if (level === 1) return 'error';
        } else if (maxLevel === 3) {
            if (level === 3) return 'success';
            if (level === 2) return 'grey';  // 'orange' might need to be changed as well
            if (level === 1) return 'error';
        }
        return undefined;
    }

    const getIndicatorIcon = (level: number) => {
        const color = getIndicatorClass(level);
        if (maxLevel === 4) {
            if (level >= 4) return <SVGIcon src={Icons.CheckCircle} color={color} />
            else return <SVGIcon src={Icons.ExclamationCircle} color={color} />;
        }
        else if (maxLevel === 3) {
            if (level >= 3) return <SVGIcon src={Icons.CheckCircle} color={color} />
            else return <SVGIcon src={Icons.ExclamationCircle} color={color} />;
        }
    }

    useEffect(() => {
        setAccordionMap(new Map<number, boolean>());
    }, [scanCriteria]);

    return (
        <React.Fragment>
            <h3>
                {scanCriteria.title}
            </h3>

            {scanCriteria.criteria_points.length === 0 &&
                <p>
                    No data available
                </p>
            }

            {scanCriteria.criteria_points.map((item, index) => {
                return (
                    <div
                        key={index}
                        className='immersion__results__accordion'
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className='immersion__results__accordion__heading'>
                            <div className={`immersion__results__accordion__heading__icon immersion__results__accordion__heading__icon__${getIndicatorClass(item.result.level)}`}>
                                {getIndicatorIcon(item.result.level)}
                            </div>
                            <h6 className='immersion__results__accordion__heading__text'>
                                {item.title}
                            </h6>

                            <div className='immersion__results__accordion__heading__button'>
                                <SVGIcon src={Icons.Chevron} rotation={accordionMap.get(index) ? 180 : 0} color='primary' />
                            </div>
                        </div>
                        {accordionMap.get(index) && item.result.review

                            ? <div className='immersion__results__accordion__description'>
                                <p className='mice immersion__results__accordion__description__text'>
                                    {item.result.review}
                                </p>
                            </div>
                            : null
                        }
                    </div>
                )
            })}
        </React.Fragment>
    )
}

export default ResultAccordion;